import { createClient } from '@supabase/supabase-js'

// Anon (publishable) key only — the service-role key never reaches the frontend.
const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set (see frontend/.env.example).',
  )
}

export const supabase = createClient(url, anonKey)
